import { render, staticRenderFns } from "./MigrationMain.vue?vue&type=template&id=63aef662&scoped=true"
import script from "./MigrationMain.vue?vue&type=script&lang=js"
export * from "./MigrationMain.vue?vue&type=script&lang=js"
import style0 from "./MigrationMain.vue?vue&type=style&index=0&id=63aef662&prod&lang=scss&scoped=true"
import style1 from "./MigrationMain.vue?vue&type=style&index=1&id=63aef662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aef662",
  null
  
)

export default component.exports